<template>
    <div class="pop-quit" v-show="showQuitModal" v-cloak @click="closeQuitModal">
            <div class="pop-body" @click="preventDefault">
                <img :src="imgUrl" class="img" @click="toFreeGet">
            </div>
        </div>
</template>

<script>

import $ from 'jquery'
import baseMethod from 'common/js/baseMethod.js'

export default {
    name: 'TuiaQuitBox',
    props:['showQuitModal', 'channelId', "phone", "tuiaId"],
    created(){
        // if(baseMethod.isNewChannel(this.channelId)){
        //     if(baseMethod.isGuangdiantongChannel(this.channelId)){
        //         this.id = '457760'
        //         this.tuiaParam = {id:"457760",width:"510",height:"510"}
        //     } else {
        //         this.id = '457759'
        //         this.tuiaParam = {id:"457759",width:"750",height:"1013"}
        //     }
        // }  else if("5200501001" == this.channelId){
        //         this.id = '461886'
        //         this.tuiaParam = {id:"461886",width:"650",height:"850"}
        // }else {
        //     if(baseMethod.isGuangdiantongChannel(this.channelId)){
        //         this.id = '457760'
        //        this.tuiaParam = {id:"457760",width:"510",height:"510"}
        //     } else {
        //         this.id = '457759'
        //         this.tuiaParam = {id:"457759",width:"750",height:"1013"}
        //     }
        // }
        // TuiaSDK.create([this.tuiaParam]);
    },
    data(){
        return{
            id: '',
            tuiaParam: {},
            imgUrl: ""
        }
    },
    watch:{
        //  showQuitModal(now, old) {
        //      var _this = this;
        //     if (now && !old) {
        //          TuiaSDK.getMaterial(_this.id, (image) => {
        //             _this.imgUrl = image;
        //             TuiaSDK.sendExposure(_this.id)
        //         })  
        //     }
        // }
    },
    methods: {
        toFreeGet(){
            window.location.href="https://engine.6wn9tvuhh6.cn/index/activity?appKey=2L46pGwwDGwUA6grDBuTSS2d6ek8&adslotId=462689";
        },
        preventDefault(e) {
            e.stopPropagation()
        },
        closeQuitModal(){
            this.$emit("closeQuitModal");
        }
    }
}
</script>


<style scoped>
    .pop-quit {
        position: fixed;
        z-index: 99999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .pop-quit .pop-body {
        width: 90%;
        position: relative;
    }
    
    .pop-quit .img {
        width: 100%;
    }
    
    .pop-quit .btn-get {
        position: absolute;
        bottom: 130px;
        width: 60%;
        left: 20%;
        -webkit-animation: mymove .8s infinite;
    }

</style>



// WEBPACK FOOTER //
// TuiaQuitBox.vue?0e33028a